import { useTranslation } from 'react-i18next';

import { useClosedWorkflowInternalPositionsReportData } from '~/data/reports';
import { SavedReportSettingsType } from '~/data/reportSettings';

import { useInternalPositionsReport } from '../Common/InternalPositionsReport/useInternalPositionsReport';
import { WorkflowReportBase } from '../Common/WorkflowReportBase';
import { InternalPositionsReportConfig } from '../types';

export const ClosedWorkflowInternalPositionsReport = () => {
  const { t } = useTranslation();

  const config: InternalPositionsReportConfig = {
    reportType: SavedReportSettingsType.ClosedWorkflowInternalPositions,
    dataFetchHook: useClosedWorkflowInternalPositionsReportData,
    useReportHook: useInternalPositionsReport,
    reportTitle: t('laClosedWorkflowsReport'),
    reportSubtitle: t('laOpenWorkflowsReportIntPosition'),
  };

  return (
    <WorkflowReportBase
      config={config}
      initialColumnVisibilityModel={{
        starteDate: false,
        endDate: false,
        info: false,
        jobTitle: false,
      }}
    />
  );
};
